import { commonTypes } from '../common';


export const types = {
  SET_CARD_PAYMENT_INFO: 'UINEEDS/SET_CARD_PAYMENT_INFO',
  SET_CARD_PAYMENT_ERROR: 'UINEEDS/SET_CARD_PAYMENT_ERROR',
  SAVE_BUYBACK_INFO: 'UINEEDS/SAVE_BUYBACK_INFO',
  SET_SIGNATURE_OTP_URL: 'UINEEDS/SET_SIGNATURE_OTP_URL',
};

export const initialState = {
  buyBackInfo: null,
  cardPaymentInfo: null,
  cardPaymentError: null,
  signatureOTP: null,
  r2rToCancelInfo: null,
};

const UINeedsDeviceReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_R2R_TO_CANCEL_INFO: {
      const { newR2RToCancelInfo } = action.payload;
      const newState = {
        ...state,
        r2rToCancelInfo: newR2RToCancelInfo,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      }
    }
    case types.SET_CARD_PAYMENT_INFO: {
      const { cardPaymentInfo } = action.payload;
      const newState = {
        ...state,
        cardPaymentInfo,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_CARD_PAYMENT_ERROR: {
      const { cardPaymentError } = action.payload;
      const newState = {
        ...state,
        cardPaymentError,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SAVE_BUYBACK_INFO: {
      const { payload } = action;

      if (payload) {
        const newState = {
          ...state,
          buyBackInfo: payload,
        };

        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }

      return null;
    }
    case types.SET_SIGNATURE_OTP_URL: {
      const { signatureOTP } = action.payload;
      const { phoneNumberOTP, signatureURL } = signatureOTP;
      if (phoneNumberOTP && signatureURL) {
        const newState = {
          ...state,
          signatureOTP: {
            phoneNumberOTP,
            signatureURL,
          },
        };

        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }
      return null;
    }
    default:
      return null;
  }
};

export const actions = {
  setCardPaymentInfo: cardPaymentInfo => ({
    type: types.SET_CARD_PAYMENT_INFO,
    payload: {
      cardPaymentInfo,
    },
  }),
  setCardPaymentError: cardPaymentError => ({
    type: types.SET_CARD_PAYMENT_ERROR,
    payload: {
      cardPaymentError,
    },
  }),
  saveBuyBackInfo: data => ({
    type: types.SAVE_BUYBACK_INFO,
    payload: data,
  }),
  setSignatureOTPUrl: signatureOTP => ({
    type: types.SET_SIGNATURE_OTP_URL,
    payload: {
      signatureOTP,
    },
  }),
};

export default UINeedsDeviceReducer;
